/**
 * 토큰 저장 및 관리 유틸리티
 */
export const tokenStorage = {
  /**
   * 토큰 가져오기
   */
  getToken(): string | null {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('token');
  },

  /**
   * 토큰 저장
   */
  setToken(token: string): void {
    if (typeof window === 'undefined') return;
    localStorage.setItem('token', token);
  },

  /**
   * 토큰 삭제
   */
  clearToken(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem('token');
  },

  /**
   * 토큰 존재 여부 확인
   */
  hasToken(): boolean {
    return !!this.getToken();
  },
};

/**
 * 기존에 사용되던 localStorage 키들을 정리하는 함수
 * PMS에서 이식한 로직
 */
export const cleanupDeprecatedKeys = () => {
  if (typeof window === 'undefined') return;

  const DEPRECATED_KEYS = [
    /**
     * 유저가 마지막으로 선택한 지점 목록 저장하는 용도로 사용
     * - `USER_STORE_LOCALSTORAGE_KEY`로 이동
     */
    'branch_id',
    /**
     * 위의 branch_id를 잘못 사용하여 생성된 키
     */
    'branchId',
    /**
     * 로그인 시 유저 정보 기록하는 용도로 사용
     * - `USER_STORE_LOCALSTORAGE_KEY`로 이동
     */
    'pms-user',
    /**
     * 탭 정보 저장하는 용도로 사용
     * - `TAB_STORE_LOCALSTORAGE_KEY`로 이동
     */
    'tabs',
  ];

  DEPRECATED_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
};
